import parsePhoneNumber, { PhoneNumber } from 'libphonenumber-js';

import { User } from '../types';
import { ForbiddenErrorErrorEnum, ForbiddenErrorStatusEnum, UserOrganizationResponse } from '@cdaas/api-clients/dist/asset-user-openapi';

export const typeGuards = {
  isForbiddenErrorResponse(response: unknown): response is { status: number; data: { error: string } } {
    return (
      response != null &&
      typeof response === 'object' &&
      'status' in response &&
      response.status === ForbiddenErrorStatusEnum.NUMBER_403 &&
      'data' in response &&
      response.data != null &&
      typeof response.data === 'object' &&
      'error' in response.data &&
      typeof response.data.error === 'string' &&
      Object.values<string>(ForbiddenErrorErrorEnum).includes(response.data.error)
    );
  },
  isPhoneNumberNotVerifiedForbiddenErrorResponse: (
    response: unknown,
  ): response is { status: number; data: { error: string; phone_number: string } } => {
    return (
      typeGuards.isForbiddenErrorResponse(response) &&
      response.data.error === ForbiddenErrorErrorEnum.PhoneNumberNotVerified &&
      'phone_number' in response.data &&
      typeof response.data.phone_number === 'string'
    );
  },
  isUser: (object: unknown): object is User => {
    return (
      (object as User).email !== undefined &&
      (object as User).given_name !== undefined &&
      (object as User).family_name !== undefined &&
      (object as User).phone_number !== undefined &&
      (object as User).user_roles !== undefined
    );
  },
};

export const parsingHelpers = {
  extractPartsFromFullPhoneNumber: (phoneNumber: string): PhoneNumber | undefined => parsePhoneNumber(phoneNumber),
};

export const isNumeric = (num: unknown) => num !== null && !Number.isNaN(Number(num));

export const isWebshopEnabled = (
  selectedOrganization?: UserOrganizationResponse | null,
  ownOrganization?: UserOrganizationResponse | null,
): boolean => !!(selectedOrganization ?? ownOrganization)?.webshop_enabled;
